module.exports = __webpack_public_path__ + "static/media/notifications-icon.b612accf.png";